module.exports = {
	props: {
		defaultSortQuery: {
			type: String
		}
	},

	data() {
		return {
			showSort: false,
			sortableQuery: this.defaultSortQuery,
			sorting: false
		}
	},

	methods: {
		sortableLoaded(items) {
			this.sorting  = false;
			this.showSort = items;
		}
	}

}
